module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/role-accessibility/role-accessibility.component.scss
// module id = ./src/app/admin/role-accessibility/role-accessibility.component.scss
// module chunks = main